import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRazerComponent } from './simple-icons-razer.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRazerComponent ],
    exports:      [ SimpleIconsRazerComponent ],
    bootstrap:    []
})
export class SimpleIconsRazerModule {}
